import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_g593ctghc8: FaireBrandEntity = {
  token: "b_g593ctghc8",
  type: "brand",
  name: "Abstinence Spirits",
  avatarUrl:
    "https://cdn.faire.com/fastly/934441395b92c5142b15cfb1fa6abd32b9a392ab9e5dddd3a9635735930d8b0f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/600818b529545d88fbe71edb8e654c1bd4f3d5966bd25b7bda204daa12d78b03.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/934441395b92c5142b15cfb1fa6abd32b9a392ab9e5dddd3a9635735930d8b0f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/600818b529545d88fbe71edb8e654c1bd4f3d5966bd25b7bda204daa12d78b03.jpeg",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 800,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Abstinence Spirits alcohol-free spirits and aperitifs deliver great taste and sophistication to your cocktails, without the alcohol. Designed to enhance any beverage, in an alcohol flexible world. We are made in Cape Town, South Africa, and many of our hero botanicals are unique to our homeland. A portion of our sales are donated to protect and conserve the ecological diversity from which we draw our inspiration.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.463Z",
    importedBy: "entity-db-cli",
  },
};
